<template>
  <div class="guest-nogoods-page">
    <el-form :model="guestSetting" label-position="left">
      <el-form-item label="用户姓名">
        <el-select v-model="selGuest" filterable remote reserve-keyword placeholder="请输入用户姓名" value-key="GuestCode" :remote-method="getGuest" :loading="loading">
          <el-option v-for="item in guestList" :key="item.GuestCode" :label="item.GuestName" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商品品名">
        <el-col :span="22">
          <el-select style="width:100%" v-model="selProducts" filterable multiple remote reserve-keyword placeholder="请输入商品名称" value-key="ProductCode" :remote-method="getProducts" :loading="loading">
            <el-option v-for="item in productList" :key="item.ProductCode" :label="item.ProductName" :value="item"></el-option>
          </el-select>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onAddUserNoGoods">添加到列表</el-button>
        <el-button type="primary" @click="onSaveUserNoGoods">保存数据</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="setDatas" border style="width: 100%" v-loading="loading">
      <el-table-column prop="GuestName" label="用户姓名" width="180"></el-table-column>
      <el-table-column prop="ProductNames" label="排除的商品"></el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button @click="onEditNoGoods(scope.row)" type="primary" size="mini">编辑</el-button>
          <el-button @click="onDeleteNoGoods(scope.row,scope.$index)" type="primary" size="mini">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getSettings, saveSetting } from "../../api/setting";
import { searchGuests, getGuests } from "../../api/guest";
import { searchProducts, getProducts } from "../../api/product";

export default {
  data() {
    return {
      curSetting: { ID: 0 },
      guestSetting: {
        GuestCode: "",
        GuestName: "",
      },
      selGuest: {},
      setDatas: [],
      guestList: [],
      productList: [],
      selProducts: [],
      loading: false,
    };
  },
  created() {
    this.loadSetting();
  },
  methods: {
    loadSetting: function () {
      let that = this;
      that.loading = true;
      getSettings("GUEST_SETTING", "GUEST_NO_GOODS").then(
        (resp) => {
          that.loading = false;
          if (resp.data.code == 100) {
            that.setDatas = [];
            if (resp.data.data.length > 0) {
              that.curSetting = resp.data.data[0];
              var setValue = resp.data.data[0].SetValue;
              let objValue = JSON.parse(setValue);

              let guestCodes = "";
              let prodCodes = "";
              for (var gcode in objValue) {
                let pcode = objValue[gcode];
                pcode = pcode.replace(/[ "]/g, "").replace(/,/g, ";");
                prodCodes += pcode + ";";
                guestCodes += gcode + ";";
              }

              let p1 = getGuests(guestCodes);
              let p2 = getProducts(prodCodes);
              Promise.all([p1, p2]).then((vals) => {
                for (var gcode in objValue) {
                  let guests = vals[0].data.data;
                  let products = vals[1].data.data;
                  let curGuest = {};
                  let prodNames = "";
                  let pcodes = objValue[gcode].split(",");
                  let gList = [];
                  for (var i = 0; i < guests.length; i++) {
                    if (gcode == guests[i].GuestCode) {
                      curGuest = guests[i];
                      break;
                    }
                  }
                  for (var i = 0; i < pcodes.length; i++) {
                    for (var n = 0; n < products.length; n++) {
                      if (pcodes[i] == '"' + products[n].ProductCode + '"') {
                        gList.push(products[n]);
                        prodNames += products[n].ProductName + ";";
                        break;
                      }
                    }
                  }
                  let sdata = {
                    GuestCode: gcode,
                    GuestName: curGuest.GuestName,
                    ProductNames: prodNames,
                    GoodsList: gList,
                  };
                  that.setDatas.push(sdata);
                }
              });
            }
          } else {
            that.$notify.error({
              title: "失败",
              message: "加载数据失败：" + resp.data.msg,
            });
          }
        },
        (err) => {
          that.loading = false;
          that.$notify.error({ title: "查询失败", message: err.statusText });
        }
      );
    },
    onBtnSearch: function () {
      this.queryCondition.pageindex = 1;
      this.onSearch();
    },
    getGuest: function (inpName) {
      let that = this;
      searchGuests({
        GuestName: inpName,
        EnableFlag: "1",
        pageindex: 1,
        pagesize: 50,
      }).then((resp) => {
        if (resp.data.code == 100) {
          that.guestList = resp.data.data.Data;
        }
      });
    },
    getProducts: function (prodName) {
      let that = this;
      searchProducts({
        ProductName: prodName,
        EnableFlag: 100,
        pageindex: 1,
        pagesize: 50,
      }).then((resp) => {
        if (resp.data.code == 100) {
          that.productList = resp.data.data.Data;
        }
      });
    },
    onSearch: function () {
      var that = this;
      this.loading = true;
      searchSettings(this.queryCondition).then(
        (resp) => {
          that.loading = false;
          if (resp.data.code == 100) {
            that.setDatas = resp.data.data.Data;
            that.queryCondition.count = resp.data.data.Count;
          } else {
            that.$notify.error({
              title: "失败",
              message: "加载数据失败：" + resp.data.msg,
            });
          }
        },
        (err) => {
          that.loading = false;
          that.$notify.error({ title: "查询失败", message: err.statusText });
        }
      );
    },
    onAddUserNoGoods: function () {
      if (this.selGuest == null || !this.selGuest.GuestCode) {
        this.$notify.error({ title: "未选择用户", message: "请选择用户" });
      }
      if (this.selProducts == null || this.selProducts.length == 0) {
        this.$notify.error({ title: "未选择商品", message: "请选择商品" });
      }
      var prodNames = "";
      for (var i = 0; i < this.selProducts.length; i++) {
        prodNames += this.selProducts[i].ProductName + ";";
      }
      var guestNoGoods = {
        GuestCode: this.selGuest.GuestCode,
        GuestName: this.selGuest.GuestName,
        ProductNames: prodNames,
        GoodsList: this.selProducts,
      };
      for (var i = 0; i < this.setDatas.length; i++) {
        if (this.setDatas[i].GuestCode == this.selGuest.GuestCode) {
          this.setDatas[i] = guestNoGoods;
          this.setDatas.push({});
          this.setDatas.splice(this.setDatas.length - 1, 1);
          return;
        }
      }
      this.setDatas.push(guestNoGoods);
    },
    onSaveUserNoGoods: function () {
      var guestSet = {};
      for (var i = 0; i < this.setDatas.length; i++) {
        var data = this.setDatas[i];
        let goods = "";
        for (var n = 0; n < data.GoodsList.length; n++) {
          if (n > 0) goods += ",";
          goods += '"' + data.GoodsList[n].ProductCode + '"';
        }
        guestSet[this.setDatas[i].GuestCode] = goods;
      }
      this.curSetting.TypeCode = "GUEST_SETTING";
      this.curSetting.TypeName = "客户不显示的产品";
      this.curSetting.SetName = "GUEST_NO_GOODS";
      this.curSetting.SetValue = JSON.stringify(guestSet);
      this.curSetting.Enable = 1;
      this.loading = true;
      saveSetting(this.curSetting).then(
        (resp) => {
          this.loading = false;
          if (resp.data.code == 100) {
            this.loadSetting();
            this.$notify.success({ title: "成功", message: "保存成功" });
          } else {
            this.$notify.error({ title: "失败", message: resp.data.msg });
          }
        },
        (err) => {
          this.$notify.error({ title: "保存", message: err.statusText });
          this.loading = false;
        }
      );
    },
    onDeleteNoGoods: function (data, index) {
      if (confirm("是否要删除客户[" + data.GuestName + "]的设置")) {
        this.setDatas.splice(index, 1);
      }
    },
    onEditNoGoods: function (data) {
      let guest = { GuestCode: data.GuestCode, GuestName: data.GuestName };
      this.guestList = [guest];
      this.productList = data.GoodsList;
      this.selGuest = guest;
      this.selProducts = data.GoodsList;
    },
  },
};
</script>
